import { render, staticRenderFns } from "./ChildrenCard.vue?vue&type=template&id=548923e9"
import script from "./ChildrenCard.vue?vue&type=script&lang=js"
export * from "./ChildrenCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports